(function(){
  // Restore mode: original Shopify menu untouched. Only append one item: VVS Diamond Simulants Essentials.
  var HREF = '/collections/cz-essentials', LABEL = 'VVS Diamond Simulants Essentials';
  function append(ul){
    if(ul.dataset.montCz === '1') return;
    var lis = ul.querySelectorAll(':scope > li');
    var tmpl = null;
    lis.forEach(function(li){
      var a = li.querySelector(':scope a');
      if(a && (a.getAttribute('href')||'').indexOf('/collections/') === 0 && !li.querySelector('ul') && !tmpl) tmpl = li;
    });
    if(!tmpl){
      lis.forEach(function(li){
        var a = li.querySelector(':scope a');
        if(a && a.getAttribute('href') === '/pages/contact' && !tmpl) tmpl = li;
      });
    }
    if(!tmpl) return;
    if(ul.querySelector('a[href="'+HREF+'"]')) { ul.dataset.montCz = '1'; return; }
    var clone = tmpl.cloneNode(true);
    clone.querySelectorAll('ul, .mega-menu').forEach(function(el){ try{ el.remove(); }catch(e){} });
    var a = clone.querySelector('a');
    if(!a) return;
    a.setAttribute('href', HREF);
    a.removeAttribute('aria-current'); a.removeAttribute('id');
    var txt = null;
    a.querySelectorAll('span').forEach(function(el){ if(el.children.length === 0 && !txt) txt = el; });
    if(txt){
      txt.textContent = LABEL;
      a.querySelectorAll('span').forEach(function(el){ if(el !== txt && el.children.length === 0) el.textContent = ''; });
    } else { a.textContent = LABEL; }
    // insert before Contact if present, else append
    var contact = null;
    ul.querySelectorAll(':scope > li').forEach(function(li){
      var la = li.querySelector(':scope a');
      if(la && la.getAttribute('href') === '/pages/contact' && !contact) contact = li;
    });
    if(contact) ul.insertBefore(clone, contact); else ul.appendChild(clone);
    ul.dataset.montCz = '1';
  }
  function run(){
    document.querySelectorAll('header overflow-list, .header-menu overflow-list, .header-menu ul').forEach(function(el){
      if(!el.closest('li') && el.querySelector(':scope > li a')) append(el);
    });
    document.querySelectorAll('.menu-drawer ul, menu-drawer ul, [class*="menu-drawer"] ul').forEach(function(ul){
      if(!ul.closest('li') && ul.querySelector(':scope > li a')) append(ul);
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function(){ run(); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

(function(){
  // Submenu items: Men gets CHAINS; Women gets BRACELETS/EARRINGS/RINGS. Cloned from existing child items.
  var CDN = '//montierjewelryofficial.com/cdn/shop/collections/';
  function setImg(clone, file){
    var url = CDN + file + '&width=800';
    clone.querySelectorAll('source').forEach(function(s){ try{ s.remove(); }catch(e){} });
    var img = clone.querySelector('img');
    if(img){
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.setAttribute('src', url);
      img.setAttribute('srcset', url + ' 800w');
      img.setAttribute('width', '800'); img.setAttribute('height', '800');
    }
  }
  function makeItem(tmplLi, href, label, imgFile){
    var clone = tmplLi.cloneNode(true);
    var a = clone.querySelector('a');
    if(!a) return null;
    a.setAttribute('href', href);
    a.removeAttribute('id'); a.removeAttribute('aria-current');
    setImg(clone, imgFile);
    var txt = null;
    a.querySelectorAll('span').forEach(function(el){ if(el.children.length === 0 && !txt) txt = el; });
    if(txt){ txt.textContent = label; } else { a.textContent = label; }
    img = clone.querySelector('img');
    if(img) img.setAttribute('alt', label);
    return clone;
  }
  function fillMen(){
    document.querySelectorAll('a[href="/collections/bracelets-1"]').forEach(function(a){
      var li = a.closest('li'); if(!li) return;
      var ul = li.parentElement; if(!ul) return;
      if(ul.querySelector('a[href="/collections/chains"]')) return;
      var item = makeItem(li, '/collections/chains', 'CHAINS', '87fef6bef1f79eecb9aedbdf7d83c3fa.jpg?v=1784633945');
      if(item) ul.insertBefore(item, li);
    });
  }
  function fillWomen(){
    document.querySelectorAll('a[href="/collections/necklaces"]').forEach(function(a){
      var li = a.closest('li'); if(!li) return;
      var ul = li.parentElement; if(!ul) return;
      // only submenus (necklaces also appears in tiles/footer) - require menu context
      if(!li.className.match(/menu|list-item/) && !ul.className.match(/menu/)) return;
      if(ul.querySelector('a[href="/collections/rings"]')) return;
      var items = [
        ['/collections/bracelets', 'Bracelets', '170c3f13fadc8b14d1e0b9aa06eb2333.jpg?v=1'],
        ['/collections/earrings', 'Earrings', '92daccd55e9dfb087b132a91a11e9441.jpg?v=1']
      ];
      items.forEach(function(it){
        var el = makeItem(li, it[0], it[1], it[2]);
        if(el) ul.insertBefore(el, li);
      });
      var rings = makeItem(li, '/collections/rings', 'Rings', 'b12e93ea69d36db8f977d02b78a8c7c7.jpg?v=1');
      if(rings) ul.insertBefore(rings, li.nextSibling);
    });
  }
  function run(){ fillMen(); fillWomen(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function(){ run(); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
